import { Account } from '@/domain/usecases'
import { FeatureFlag } from '@/infra/feature-flag/feature-flag'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { QueryClient } from 'react-query'
import { RecordsDefer } from './base-loader'
import RegisteredPlanBaseLoader from './registered-plan-base-loader'

export default abstract class AddonBaseLoader extends RegisteredPlanBaseLoader {
  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient,
    readonly ldClient: LDClient | undefined,
    readonly requiredFeatureFlag: FeatureFlag.Key | undefined,
    readonly addonName: string
  ) {
    super(account, queryClient, ldClient, requiredFeatureFlag)
  }

  async defer(deferRecords: RecordsDefer) {
    const accountProfile = this.getAccount()
    const addon = accountProfile.addons?.[this.addonName as keyof typeof accountProfile.addons]
    if (!addon?.enabled) return this.notAllowedLoader.bind(this)()
    return super.defer(deferRecords)
  }
}
